// extracted by mini-css-extract-plugin
export default {"Message":"campaignAdhocView_Message__M+Ouu"};